import Service, { getCallApiFunction } from '../service'
import { TUserProfile } from '@/types/user-profile'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'
// 定義 TypeScript 型別

type MemberBaseType = {
  memberBase: TUserProfile
}
export type KolType = {
  accumulateViews: number
  appendix: string | null
  coverPhoto: string
  createdAt: string
  creatorId: number
  facebookUrl: string | null
  followerNum: number
  id: number
  instagramUrl: string | null
  intro: string | null
  isDel: boolean
  memberInfoId: string
  modifiedAt: string
  modifierId: number
  otherContact: string | null
  source: number
  email: string
}

export type MerchantType = {
  contactNumber: string
  contactPerson: string
  coverPhoto: string | null
  createdAt: string
  creatorId: number
  email: string
  facebookUrl: string | null
  id: number
  instagramUrl: string | null
  intro: string | null
  isDel: boolean
  isFeatured: boolean
  memberInfoId: string
  modifiedAt: string
  modifierId: number
  phone: string
  phoneCountry: string
  source: number
  storeName: string
  websiteUrl: string | null
}
export enum ROLE_TYPE_ENUM {
  KOL = 'KOL',
  MERCHANT = 'Merchant',
}
export type MerchantResponse = {
  merchant: MerchantType
} & MemberBaseType
export type KolResponse = {
  kol: KolType
} & MemberBaseType

export type KOLOrMerchantInfoApiRes = Promise<MerchantResponse | KolResponse>

export type KOLOrMerchantInfoApiParams = {
  role: ROLE_TYPE_ENUM
  roleId: string
}

class FetchMemberRoleInfoApi extends Service {
  constructor({ role, roleId }: KOLOrMerchantInfoApiParams) {
    super()
    this.name = 'FETCH_MEMBER_ROLE_INFO'

    this.config = {
      url: `/v1/livemall/member/${role}/${roleId}`,
      method: 'GET',
    }
  }
}

export const fetchMemberRoleInfo = (params: KOLOrMerchantInfoApiParams): KOLOrMerchantInfoApiRes =>
  getCallApiFunction(new FetchMemberRoleInfoApi(params))
